import { Link, useNavigate } from 'react-router-dom';
import { LoginForm } from '@/pages/auth/LoginForm';
import { CHOOSE_APP_PATH } from '@/constants/authRoutes';
import { getPostLoginPath } from '@/utils/moduleScope';
import {
  isFattahOneProductSelectionRequired,
  isPlatformOnboardingRequired,
} from '@/modules/onboarding/onboardingState';
import { resolveOwnerHomePath } from '@/utils/moduleAccess';

export function FattahLoginPage() {
  const navigate = useNavigate();

  return (
    <div>
      <LoginForm
        showRegisterLink
        onLoginSuccess={(result) => {
          if (result.masterAdmin) {
            navigate('/master', { replace: true });
            return;
          }
          if (isFattahOneProductSelectionRequired()) {
            navigate('/onboarding/products', { replace: true });
            return;
          }
          if (isPlatformOnboardingRequired()) {
            navigate('/onboarding', { replace: true });
            return;
          }
          if (result.entryModule) {
            const home = getPostLoginPath(result.entryModule as never, resolveOwnerHomePath(result.enabledModules ?? []));
            navigate(home, { replace: true });
            return;
          }
          navigate(resolveOwnerHomePath(result.enabledModules ?? []), { replace: true });
        }}
      />
      <p className="mt-6 text-center text-xs text-slate-500 dark:text-slate-400">
        Platform operator?{' '}
        <Link to="/master/login" className="font-medium text-primary-600 hover:underline dark:text-primary-400">
          Master sign in
        </Link>
        {' · '}
        <Link to={CHOOSE_APP_PATH} className="font-medium text-primary-600 hover:underline dark:text-primary-400">
          Product sign-in
        </Link>
      </p>
    </div>
  );
}
